import { render } from "./OkrElementCreator.vue?vue&type=template&id=51645423&scoped=true"
import script from "./OkrElementCreator.vue?vue&type=script&lang=js"
export * from "./OkrElementCreator.vue?vue&type=script&lang=js"

import "./OkrElementCreator.vue?vue&type=style&index=0&id=51645423&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51645423"]])

export default __exports__